import React, {Component} from 'react'
import './index.css'
import localization from "../../../config/localization"
import {
  homePathGenerator, parseRouting,
  setPageTitle
} from "../../../api-client/core/authentication/utils";
import {Route, Router, Switch} from "react-router-dom";
import SmartSearchContentCreatorType from "./SmartSearchContentCreatorType";
import SmartSearchContentCreation from "./SmartSearchContentCreation";
import SmartSearchContentCreator from "./SmartSearchContentCreator";
import browserHistory from "../../../utils/browserHistory";

class SmartSearch extends Component {

  state = {
    search: "",
    searchType: window.location.pathname.indexOf("/busqueda-inteligente/creaciones") > 0 ? "creations" : "creators",
  }

  componentDidMount = () => {
    setPageTitle(localization.get('title.smart_search'))
    document.getElementsByTagName("html")[0].scrollTop = 0;

    if (window.location.pathname.includes("busqueda-inteligente/creaciones") && this.state.searchType !== "creations") {
      this.setState({searchType: "creations"})
    }else if ((window.location.pathname.includes("busqueda-inteligente/creadores") && this.state.searchType === "creations") ||
      (window.location.pathname.includes("busqueda-inteligente")
        && !window.location.pathname.includes("busqueda-inteligente/creaciones") && this.state.searchType === "creations")) {
      this.setState({searchType: "creators"})
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (window.location.pathname.includes("busqueda-inteligente/creaciones") && this.state.searchType !== "creations") {
      this.setState({searchType: "creations"})
    }else if ((window.location.pathname.includes("busqueda-inteligente/creadores") && this.state.searchType === "creations") ||
      (window.location.pathname.includes("busqueda-inteligente")
        && !window.location.pathname.includes("busqueda-inteligente/creaciones") && this.state.searchType === "creations")) {
      this.setState({searchType: "creators"})
    }
  }

  SmartSearch = (props) => <SmartSearchContentCreatorType  {...props}/>
  SmartSearchContentCreator = (props) => <SmartSearchContentCreator {...props}/>
  SmartSearchContentCreation = (props) => <SmartSearchContentCreation  {...props}/>

  render = () => {
    return (
      <div id="innerinner" style={{ marginBottom: '10px' }}>
        {/*<AsyncSelect
          className={"smart-search-category-searchbar"}
          styles={{
            menu: base => ({
              ...base,
              zIndex: 10,
              borderRadius: 4,
            }),
            valueContainer: base => ({
              base,
              paddingLeft: 30
            })
          }}
          theme={theme => {
            return ({
              ...theme,
              paddingLeft: 30,
              colors: {...theme.colors, neutral0: "rgba(240, 240, 240, 1)"},
              borderRadius: 30,
              borderColor: "#ccc",
            })
          }}
          input={styles => ({
            ...styles,
          })}
          valueContainer={<Search style={{position: "absolute", zIndex:10}}/>}
          placeholder={localization.get('conversation.filter_users')}
          loadingMessage={() => localization.get('loading')}
          noOptionsMessage={() => localization.get('no_options')}
          onChange={e => this.setState({search: e})}
          value={this.state.search}
          defaultOptions
          isClearable={true}
          loadOptions={inputValue =>{
            let filters = [{column: "name", filter: inputValue}]
            return request.contentCreatorType.getAll({filterBy: filters})
              .then(res => res.map(category => ({value: category.id, label: category.name})))
          }}
        />*/}
        <div className={"smart-search-category-type-selection"}>
          <div
            className={`${this.state.searchType === "creators" ? "smart-search-category-type-selected" : "smart-search-category-type-not-selected"}`}
            style={{
              width: "100%",
              borderBottomLeftRadius: 30,
              borderTopLeftRadius: 30,
              lineHeight: "36px"
            }}
            onClick={() => this.setState({searchType: "creators"}, () => browserHistory.push(homePathGenerator("busqueda-inteligente")))}
          >
            <p className={"smart-search-category-type"} style={{ cursor: "pointer" }}>{localization.get('favorites.creators')}</p>
          </div>
          <div
            style={{
              width: "100%",
              borderBottomRightRadius: 30,
              borderTopRightRadius: 30,
              lineHeight: "36px"
            }}
            className={`${this.state.searchType === "creations" ? "smart-search-category-type-selected" : "smart-search-category-type-not-selected"}`}
            onClick={() => this.setState({searchType: "creations"}, () => browserHistory.push(homePathGenerator("busqueda-inteligente/creaciones")))}
          >
            <p className={"smart-search-category-type"} style={{ cursor: "pointer" }}>{localization.get('favorites.creations')}</p>
          </div>
        </div>

        <Router {...this.props}>
          <Switch>
            <Route path={parseRouting("busqueda-inteligente/creaciones")} render={wrap(this.SmartSearchContentCreation)}/>
            <Route path={parseRouting("busqueda-inteligente/contenido")} render={wrap(this.SmartSearchContentCreator)}/>
            <Route path={parseRouting("busqueda-inteligente")} render={wrap(this.SmartSearch)}/>
          </Switch>
        </Router>
      </div>
    )}
}

const wrap = (Comp) => props => {
  return <Comp {...props}/>
}

export default SmartSearch;